import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min';
import './App.css';
import Home from "./pages/Home";
import Category from "./pages/Category";
import Post from "./pages/Post";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import Help from "./pages/Help";
/*
import Story from "./pages/Article";

import Login from "./pages/Login";
*/
import NotFound from './pages/NotFound';
import Navigation from "./components/Navigation"
import Footer from "./components/Footer"


const App = () => {
  return (
    <div className="container">
      <Router>
        <Navigation />
        <Switch>
          <Route exact path="/" component={Home} />
          {/* <Route path="/article/:id" component={Story} /> */}       
          <Route exact path="/login" component={Login} />
          <Route exact path="/profile" component={Profile} />
          <Route path="/category/:id" component={Category} />
          <Route path="/post/:id" component={Post} />
          <Route exact path="/help" component={Help} />
          <Route component={NotFound} />
        </Switch>
        <Footer />
      </Router>
    </div>
    
  );
};

export default App;

